<template>
  <div id="app">
    <!-- <PersonAdmin/> -->
    <HelloWorld msg="Welcome to ClubTrack"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'


export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
html{
  height:100vh;
  padding:0px;
  display:grid;
}
body{
  height:100vh;
  padding:0px;
  margin:0px;
  display:grid;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
